import { Loader2 } from "lucide-react";

interface LoadingProps {
  size?: number;
  className?: string;
  text?: string;
}

export function Loading({ size = 24, className = "", text }: LoadingProps) {
  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <Loader2 className="animate-spin text-white" size={size} />
      {text && <p className="mt-2 text-sm text-neutral-500">{text}</p>}
    </div>
  );
}

export function FullPageLoading({
  text = 'Loading...',
  size = 32,
  fullScreen = true,
  className = ''
}: { text?: string; size?: number; fullScreen?: boolean; className?: string }) {
  return (
    <div className={`${fullScreen ? 'min-h-screen' : 'min-h-[60vh]'} w-full flex items-center justify-center  text-white ${className}`}>
      <Loading size={size} text={text} className="text-white" />
    </div>
  );
}
